import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

/**
 * MainTitle:
 *   - Maintitle for all Lelvel Selector Components
 */
export function MainTitle(props) {
  const className = `${style.text} ${props.className}`;
  return <h2 className={className}>{props.title}</h2>;
}

MainTitle.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Title text
   */
  title: PropTypes.string,
};

MainTitle.defaultProps = {
  title: 'Select a level',
  className: '',
};
